












































import CostCardDocuments from "@/components/cost/CostCardDocuments.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { ISignDocument } from "@/models/sign-document.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LineItemsForm from "./LineItemsForm.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";

@Component({
  components: {
    LineItemsForm,
    CostCardDocuments,
    ConfirmActionDialog
  },
  filters: {}
})
export default class RepairEstimateDetailAddResponse extends mixins(RulesMixin) {
  readonly CurrencyEnum = CurrencyEnum;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  @Prop()
  value!: IRepairEstimate;

  valueCopy = new RepairEstimate({ id: this.value.id, partnerId: this.value.partnerId });

  isDialogActive = false;

  isConfirmLoading = false;

  isValid = false;

  get documentIds() {
    return this.valueCopy.documentId ? [this.valueCopy.documentId] : [];
  }

  set documentIds(documentIds: string[]) {
    this.open();
    this.valueCopy.documentId = documentIds[documentIds.length - 1];
  }

  async onCreatedDocument(...documents: ISignDocument[]) {
    this.$log.debug(documents);

    if (!this.valueCopy.number && documents.length) {
      const number = documents
        .map(d => {
          if (d.title?.endsWith(".pdf")) {
            return d.title.substring(0, d.title.length - 4);
          }
          return d.title;
        })
        .join("; ") as string;

      if (this.valueCopy.date === new Date().toISOString().slice(0, 10)) {
        this.valueCopy.date = documents[0].timestamp.created.slice(0, 10);
      }
      this.valueCopy.number = number;
    }
  }

  open() {
    this.isDialogActive = true;
    this.valueCopy = new RepairEstimate(this.value);
    if (!this.valueCopy.lineItems?.length) {
      this.valueCopy.lineItems = [new InvoiceLine({ title: "Position" })];
    }
  }

  cancel() {
    this.isDialogActive = false;
    this.valueCopy.documentId = "";

    // hack to reset the file input
    this.$nextTick(() => {
      this.valueCopy.documentId = undefined;
    });
  }

  async confirm() {
    try {
      this.isConfirmLoading = true;

      await this.value.updatePartial({
        documentId: this.valueCopy.documentId,
        number: this.valueCopy.number,
        currency: this.valueCopy.currency,
        status: this.valueCopy.lineItems.length && this.valueCopy.documentId ? RequestStatusEnum.REPLIED : undefined,
        lineItems: this.valueCopy.lineItems
      });
      this.isDialogActive = false;
      this.$emit("change", this.value.documentId);
    } catch (e) {
      handleError(e);
    } finally {
      this.isConfirmLoading = false;
    }
  }
}
